import Vue from 'vue';
import VueRouter from 'vue-router';

import { publicRoutes } from './public-routes';
import { visitorRoutes } from './visitor-dashboard-routes';
import { authRoutes } from './auth-routes';
import { appointmentsRoutes } from './dashboard-appointments-route';
import { liveCommunicationRoutes } from './live-communication-routes';
import { defaultRoutes } from './default-routes';
import { meetingLinkRoutes } from "./meeting-link-routes.js";

Vue.use(VueRouter);

let routes = [
	...publicRoutes,
    ...authRoutes,
    ...visitorRoutes,
    ...appointmentsRoutes,
    ...liveCommunicationRoutes,
	...meetingLinkRoutes,
	{
		path: '/dashboard',
		name: 'Dashboard',
        layout: "dashboard",
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
		meta: {
			requiresAuth: true,
            title: 'Dashboard | Appointment Portal RDCD',
            displayTitle: 'page-titles.dashboard',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
    {
		path: '/dashboard/official',
		name: 'DashboardOfficial',
        layout: "dashboard",
		component: () => import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue'),
		meta: {
			requiresAuth: true,
            title: 'Dashboard | Appointment Portal RDCD',
            displayTitle: 'page-titles.dashboard',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/designations',
		name: 'Designations',
        layout: "dashboard",
		component: () => import(/* webpackChunkName: "designations" */ '../views/Designations.vue'),
		meta: {
            requiresAuth: true,
            title: 'Designations | Appointment Portal RDCD',
            displayTitle: 'page-titles.designations',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/designation/create',
		name: 'CreateDesignation',
        layout: "dashboard",
		component: () => import('../views/create/CreateDesignation.vue'),
		meta: {
            requiresAuth: true,
            title: 'Designation | Appointment Portal RDCD',
            displayTitle: 'designation-create-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/designation/edit',
		name: 'EditDesignation',
        layout: "dashboard",
		component: () => import('../views/designations/Edit.vue'),
		meta: {
            requiresAuth: true,
            title: 'Designation | Appointment Portal RDCD',
            displayTitle: 'designation-create-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/departments',
		name: 'Departments',
        layout: "dashboard",
		component: () => import(/* webpackChunkName: "departments" */ '../views/departments/Departments.vue'),
		meta: {
            requiresAuth: true,
            title: 'Departments | Appointment Portal RDCD',
            displayTitle: 'page-titles.departments',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/department/create',
		name: 'CreateDepartment',
        layout: "dashboard",
		component: () => import('../views/departments/CreateDepartment.vue'),
		meta: {
            requiresAuth: true,
            title: 'Department | Appointment Portal RDCD',
            displayTitle: 'department-create-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/department/edit',
		name: 'EditDepartment',
        layout: "dashboard",
		component: () => import('../views/departments/Edit.vue'),
		meta: {
            requiresAuth: true,
            title: 'Department | Appointment Portal RDCD',
            displayTitle: 'department-update-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	
	{
		path: '/officials',
		name: 'Officials',
		layout: "dashboard",
        component: () => import(/* webpackChunkName: "officials" */'../views/Officials.vue'),
		meta: {
            requiresAuth: true,
            title: 'Officials | Appointment Portal RDCD',
            displayTitle: 'page-titles.officials',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
	{
		path: '/official/create',
		name: 'CreateOfficial',
		layout: "dashboard",
        component: () => import('../views/create/CreateOfficial.vue'),
		meta: {
            requiresAuth: true,
            title: 'Official | Appointment Portal RDCD',
            displayTitle: 'official-create-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
    {
		path: '/official/edit',
		name: 'EditOfficial',
        layout: "dashboard",
		component: () => import('../views/officials/Edit.vue'),
		meta: {
            requiresAuth: true,
            title: 'Official | Appointment Portal RDCD',
            displayTitle: 'official-create-page.title',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
    
	
	{
		path: '/system/users',
		name: 'SystemUsers',
		layout: "dashboard",
		component: () => import('../views/SystemUsers.vue'),
		meta: {
            displayTitle: 'page-titles.system-users',
			title: "Receptions-RDCD",
			requiresAuth: true,
		},
	},
	{
		path: '/system/user/create',
		name: 'CreateSystemUser',
		layout: "dashboard",
		component: () => import('../views/create/CreateSystemUser.vue'),
		meta: {
            displayTitle: 'page-titles.system-users',
			title: "Receptions-RDCD",
			requiresAuth: true,
		},
	},
	{
		path: '/system/user/edit',
		name: 'EditSystemUser',
        layout: "dashboard",
		component: () => import('../views/system-users/Edit.vue'),
		meta: {
            requiresAuth: true,
            title: 'System User | Appointment Portal RDCD',
            displayTitle: 'page-titles.system-users',
            requiresRoles: [ 'OWNER', 'ICT', 'OFFICIAL' ]
		},
	},
    

    /* not confirmed yet */

	// {
	// 	path: '/appointments',
	// 	name: 'Appointments',
	// 	layout: "dashboard",
	// 	component: () => import(/* webpackChunkName: "appointments" */'../views/Appointments.vue'),
	// 	meta: {
	// 		title: "Appointments-RDCD",
	// 		requiresAuth: true,
	// 	},
	// },
	{
		path: '/receptions',
		name: 'Receptions',
		// layout: "dashboard",
		component: () => import(/* webpackChunkName: "receptions" */'../views/Receptions.vue'),
		meta: {
			title: "Receptions-RDCD",
			requiresAuth: true,
		},
	},
	{
		path: '/visitors',
		name: 'Visitor',
		layout: "dashboard",
		component: () => import('../views/Visitor.vue'),
		meta: {
            displayTitle: 'page-titles.visitors',
			title: "Receptions-RDCD",
			requiresAuth: true,
		},
	},
    
	
]

// Adding layout property from each route to the meta
// object so it can be accessed later.
function addLayoutToRoute( route, parentLayout = "default" ) {
	route.meta = route.meta || {} ;
	route.meta.layout = route.layout || parentLayout ;
	
	if( route.children ) {
		route.children = route.children.map( ( childRoute ) => addLayoutToRoute( childRoute, route.meta.layout ) ) ;
	}
	return route ;
}

routes = routes.map( ( route ) => addLayoutToRoute( route ) ) ;

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,
	scrollBehavior (to, from, savedPosition) {
		if ( to.history ) {
			return {
				selector: to.history,
				behavior: 'smooth',
			}
		}
		return {
			x: 0,
			y: 0,
			behavior: 'smooth',
		}
	}

});



router.beforeEach((to, from, next) => {
    
    // document.title = to.meta ? to.meta.title : 'Appointment Portal | RDCD';

    let token = localStorage.getItem('token');
    let isAuthenticated = token && token.length > 0;
    let matched = to.matched.some((record) => record.meta.requiresAuth);
    let currentRoles = [];
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.roles && currentUser.roles.length > 0) {
        currentRoles = currentUser.roles;
    }

    if (matched) {
        if (isAuthenticated) {
            if (to.meta.requiresRoles && to.meta.requiresRoles.length > 0) {
                let requiredRoles = to.meta.requiresRoles;
                
                
                const intersection = currentRoles.filter(role => requiredRoles.includes(role));
                if (intersection.length > 0)
                    next();
                else {
                    next(defaultRoutes[currentRoles[0]]);
                }
            } else {
                next();
            }
        } else {
            next("/signin");
        }
    } else {
        if (!to.meta.allowAuthenticated && isAuthenticated)
            next(defaultRoutes[currentRoles[0]]);
        else 
            next();
    }
});

export default router;
